/**
 * Content service — one named function per API resource.
 * Components call these (never `fetch` directly), so the transport stays
 * swappable. Each returns a Promise of the resource's JSON.
 */
import { fetchResource } from "lib/apiClient";

export const getSlides = (opts) => fetchResource("slides", opts);
export const getSections = (opts) => fetchResource("sections", opts);
export const getInstitutions = (opts) => fetchResource("institutions", opts);
export const getStats = (opts) => fetchResource("stats", opts);
export const getNotices = (opts) => fetchResource("notices", opts);
export const getQuickLinks = (opts) => fetchResource("quick-links", opts);
export const getGallery = (opts) => fetchResource("gallery", opts);
export const getActivity = (opts) => fetchResource("activity", opts);
export const getDepartments = (opts) => fetchResource("departments", opts);
export const getManagement = (opts) => fetchResource("management", opts);
export const getConnectEd = (opts) => fetchResource("connected", opts);
export const getAbout = (opts) => fetchResource("about", opts);
export const getAcademics = (opts) => fetchResource("academics", opts);
export const getAdmissions = (opts) => fetchResource("admissions", opts);
export const getResults = (opts) => fetchResource("results", opts);
export const getContactInfo = (opts) => fetchResource("contact", opts);
export const getSettings = (opts) => fetchResource("settings", opts);
// Active admission round per institution — drives the Admissions page heading,
// window and class list instead of the old hard-coded "2025–26".
export const getAdmissionRounds = (opts) => fetchResource("admission-rounds", opts);
// Fee payment guides and downloadable forms, both scoped by the usual `tags`
// convention: empty = every institution, otherwise those institution slugs.
export const getAdmissionResources = (opts) => fetchResource("admission-resources", opts);
// Scrolling notice strip under the homepage hero.
export const getMarquee = (opts) => fetchResource("marquee", opts);
// Teaching staff, shown on each institution page and scoped by `institution`.
export const getTeachers = (opts) => fetchResource("teachers", opts);
